<template>
  <page-wrapper ref="pageEl" :title="title">
    <loading-overlay :active="isLoading" />
    <div class="wrapper">
      <div class="row">
        <div class="col-3">
          <sc-button
            v-if="!isViewOnlyByRole"
            :route="{ name: 'SubscriberAddTrialPage' }"
            variant="secondary"
            >เพิ่มผู้ทดลองใช้งาน</sc-button
          >
        </div>
        <div class="col-3">
          <sc-button
            v-if="!isViewOnlyByRole"
            :route="{ name: 'SubscriberAddOfflinePurchase' }"
            variant="danger"
            >เพิ่ม Package (ซื้อนอกระบบ)</sc-button
          >
        </div>
      </div>
      <hr />
      <div class="row mb-3">
        <div class="col-2">
          <div class="label mb-2">สถานะ</div>
          <el-select v-model="query.status" clearable>
            <el-option
              v-for="t in status"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
        </div>
        <div class="col-2">
          <div class="label mb-2">ประเภท</div>
          <el-select v-model="query.category" clearable>
            <el-option
              v-for="t in category"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
        </div>
        <div class="col-2">
          <div class="label mb-2">บ้านเลขที่</div>
          <el-input v-model="query.addressNumber" />
        </div>
        <div class="col-2">
          <div class="label mb-2">โครงการ</div>
          <project-select v-model="selectedProject"></project-select>
        </div>
        <div class="col-2">
          <div class="label mb-2">ชื่อลูกบ้าน</div>
          <el-input v-model="query.firstName" />
        </div>
        <div class="col-2">
          <div class="label mb-2">นามสกุล</div>
          <el-input v-model="query.lastName" />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-6">
          <div class="label mb-2">ค้นหาแพ็กเกจ</div>
          <el-autocomplete
            v-slot="{ item }"
            v-model="query.packageName"
            :fetch-suggestions="fetchPackageSuggestions"
            :trigger-on-focus="false"
            :debounce="300"
            placeholder="พิมพ์ชื่อแพ็กเกจ..."
            clearable
            @select="handlePackageSelect"
          >
            <div class="package-suggestion">
              <div class="package-name">{{ item.name }}</div>
            </div>
          </el-autocomplete>
        </div>
        <div
:style="{
          marginTop: '15px'
        }" class="col-12 checkbox-only-fast-fix">
          <el-checkbox
            v-model="isFilteredByFastFix"
            :disabled="isFilteredByFastFixDisabled"
            @change="handleSearch"
            ><p class="checkbox-font">
              แพ็กเกจที่มีบริการ Fast Fix
            </p></el-checkbox
          >
          <el-checkbox
            v-model="isEmptyPricePackage"
            :disabled="isEmptyPricePackageDisabled"
            @change="handleSearch"
            ><p class="checkbox-font">
              แพ็กแรกพบ
            </p></el-checkbox
          >
          <el-checkbox
            v-model="isOnlyNonVerifySales"
            :disabled="isOnlyNonVerifySalesDisabled"
            @change="handleSearch"
            ><p class="checkbox-font">
              ดูเฉพาะ การซื้อโดยไม่สมัคร App
            </p>
          </el-checkbox>
          <el-checkbox
            v-model="isOnlyOutsideSystem"
            :disabled="isOnlyOutsideSystemDisabled"
            @change="handleSearch"
            ><p class="checkbox-font">
              ดูเฉพาะ การซื้อนอกระบบ
            </p>
          </el-checkbox>
          <el-checkbox
            v-model="isOnlyTestUser"
            :disabled="isOnlyTestUserDisabled"
            @change="handleSearch"
            ><p class="checkbox-font">
              ดูเฉพาะ User เทส
            </p>
          </el-checkbox>
          <el-checkbox
            v-model="isUnAppointed"
            :disabled="isUnAppointedDisabled"
            @change="handleSearch"
            ><p class="checkbox-font">
              รายการที่ยังไม่ได้นัดหมาย
            </p>
          </el-checkbox>
          <el-checkbox
            v-model="isB2BPackage"
            :disabled="isB2BPackageDisabled"
            @change="handleSearch"
            ><p class="checkbox-font">
              แพ็กเกจ B2B
            </p>
          </el-checkbox>
        </div>
      </div>
      <div v-if="query.homeId">
        ค้นหาด้วย Home Id: {{ query.homeId }}
      </div>
      <div class="text-end">
        <sc-button variant="primary" @click="handleSearch">ค้นหา</sc-button>
      </div>
      <div class="d-flex flex-row mb-2 mt-2">
        <p v-if="list.length" class="me-3">{{ totalCount }}</p>
      </div>
      <div class="row mb-3">
        <sc-button
          class="ms-3 col-1"
          hidden
          variant="secondary"
          @click="handleClickDownloadReport"
        >Download Report</sc-button>
      </div>
    </div>
    <div v-if="noResult" class="p-4 text-center">ไม่มีข้อมูล</div>
    <div v-else>
      <div class="row-header">
        <div class="cell center">สถานะ</div>
        <div class="cell">ลูกค้า</div>
        <div class="cell">บ้าน</div>
        <div class="cell">แพ็กเกจ</div>
        <div class="cell">ยอดชำระ</div>
        <div class="cell">ประเภท/ซื้อเมื่อ</div>
        <div class="cell center">จำนวน</div>
        <div class="cell">การนัดหมาย (ล่าสุด)</div>
      </div>
      <subscriber-row
        v-for="item in list"
        :key="item.id"
        v-bind="item"
      ></subscriber-row>
    </div>
    <div class="wrapper text-end">
      <el-pagination
        :total="total"
        :size="10"
        :current-page="query.page"
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </page-wrapper>
</template>

<script>
import {
  Autocomplete,
  Checkbox,
  Input,
  Option,
  Pagination,
  Select
} from "element-ui"
import { baanRueJaiClient } from "@/dependencies";
import { DateTime } from "luxon";
import { getDownloadedReport } from "@/god";
import PageWrapper from "@/lib/components/PageWrapper";
import ProjectSelect from "@/lib/components/ProjectSelect";
import ScButton from "@/lib/components/ScButton";
import LoadingOverlay from "@/lib/components/LoadingOverlay";
import { isNil } from "ramda";
import { getDurationAppointmentTimeText } from "@/lib/dateTime";
import { subscriptionStatus } from "@/lib/mapper";
import SubscriberRow from "../components/SubscriberRow";

function getAdminRolePermission() {
  try {
    return JSON.parse(localStorage.getItem("adminRolePermission"));
  } catch {
    return null;
  }
}

export default {
  components: {
    PageWrapper,
    SubscriberRow,
    ProjectSelect,
    ScButton,
    LoadingOverlay,
    "el-input": Input,
    "el-pagination": Pagination,
    "el-select": Select,
    "el-option": Option,
    "el-checkbox": Checkbox,
    "el-autocomplete": Autocomplete
  },
  data() {
    const title = "รายการสมาชิก";
    const list = [];
    const query = {
      firstName: null,
      lastName: null,
      page: 1,
      addressNumber: null,
      status: null,
      category: null,
      homeId: null,
      projectId: null,
      packageName: null,
      packageId: null
    };
    const reportSubscriptionStatusOption = [
      { label: "ACTIVE" , value: subscriptionStatus.ACTIVE },
      { label: "CANCELLED", value: subscriptionStatus.CANCELLED },
      { label: "UNSUBSCRIBED", value: subscriptionStatus.UNSUBSCRIBED },
      { label: "ONE TIME", value: subscriptionStatus.ONE_TIME }
    ];
    const selectedReportStatus = null;
    const isFilteredByFastFix = false;
    const isEmptyPricePackage = false;
    const isOnlyTestUser = false;
    const isOnlyNonVerifySales = false;
    const isOnlyOutsideSystem = false;
    const isUnAppointed = false;
    const isB2BPackage = false;
    const status = [
      { label: "ทั้งหมด", value: "" },
      { label: "Active", value: "active" },
      { label: "Cancelled", value: "cancelled" },
      { label: "Unsubscribed", value: "unsubscribed" },
      { label: "Expired", value: "expired" }
    ];
    const category = [
      { label: "ทั้งหมด", value: "" },
      { label: "Free Trial", value: "freeTrial" },
      { label: "One Time", value: "oneTime" },
      { label: "Subscribe", value: "subscribe" }
    ];
    const permission = getAdminRolePermission() || null;
    const selectedProject = null;
    const isSelectingFromSuggestions = false;

    return {
      title,
      list,
      query,
      total: 0,
      reportSubscriptionStatusOption,
      selectedReportStatus,
      isFilteredByFastFix,
      isEmptyPricePackage,
      isOnlyTestUser,
      isOnlyNonVerifySales,
      isOnlyOutsideSystem,
      isUnAppointed,
      isB2BPackage,
      status,
      category,
      permission,
      selectedProject,
      isSelectingFromSuggestions,
      isLoading: false
    };
  },

  computed: {
    totalCount() {
      const limit = 10;
      const currentTotalItem = this.list.length;
      const isLastPage = limit > currentTotalItem;
      const currentPage = this.query.page;
      const endNum = isLastPage ? this.total : currentPage * limit;
      const startNum = (isLastPage ? limit * currentPage - limit : endNum - limit) + 1;

      return `แสดงผล ${startNum.toLocaleString()} - ${endNum.toLocaleString()} จากทั้งหมด ${this.total.toLocaleString()}`;
    },
    noResult() {
      return !this.isLoading && this.list.length === 0;
    },
    queryParams() {
      const queryParams = this.$route.query.serviceType
      ? {
          firstName: this.query.firstName,
          lastName: this.query.lastName,
          page: this.query.page,
          addressNumber: this.query.addressNumber,
          serviceType: this.$route.query.serviceType,
          status: this.query.status,
          category: this.query.category,
          homeId: this.query.homeId,
          projectId: this.query.projectId,
          packageName: this.query.packageName,
          packageId: this.query.packageId
        }
      : {
          firstName: this.query.firstName,
          lastName: this.query.lastName,
          page: this.query.page,
          addressNumber: this.query.addressNumber,
          status: this.query.status,
          category: this.query.category,
          homeId: this.query.homeId,
          projectId: this.query.projectId,
          packageName: this.query.packageName,
          packageId: this.query.packageId
        };

      if (this.isEmptyPricePackage) {
        queryParams.isEmptyPricePackage = this.isEmptyPricePackage;
      }

      if (this.isOnlyTestUser) {
        queryParams.isOnlyTestUser = this.isOnlyTestUser;
      }

      if (this.isOnlyNonVerifySales) {
        queryParams.isOnlyNonVerifySales = this.isOnlyNonVerifySales;
      }

      if (this.isOnlyOutsideSystem) {
        queryParams.isOnlyOutsideSystem = this.isOnlyOutsideSystem;
      }

      if (this.isUnAppointed) {
        queryParams.isUnAppointed = this.isUnAppointed;
      }

      if (this.isB2BPackage) {
        queryParams.isB2BPackage = this.isB2BPackage;
      }

      return queryParams;
    },
    showAddFreeTrialButton() {
      return !this.$isCallCenter;
    },
    showReportButton() {
      return !this.$isCallCenter;
    },
    reportStatus() {
      return this.selectedReportStatus;
    },
    isViewOnlyByRole() {
      const roles = ["AC", "CC"];
      return roles.includes(this.permission?.role)
    },
    isFilteredByFastFixDisabled() {
      return this.isUnAppointed || this.isB2BPackage;
    },
    isEmptyPricePackageDisabled() {
      return this.isUnAppointed || this.isB2BPackage;
    },
    isOnlyTestUserDisabled() {
      return (
        this.isUnAppointed ||
        this.isB2BPackage ||
        this.isOnlyNonVerifySales ||
        this.isOnlyOutsideSystem
      );
    },
    isOnlyNonVerifySalesDisabled() {
      return (
        this.isOnlyTestUser ||
        this.isOnlyOutsideSystem ||
        this.isB2BPackage
      );
    },
    isOnlyOutsideSystemDisabled() {
      return (
        this.isOnlyTestUser ||
        this.isOnlyNonVerifySales ||
        this.isB2BPackage
      );
    },
    isUnAppointedDisabled() {
      return (
        this.isFilteredByFastFix ||
        this.isEmptyPricePackage ||
        this.isOnlyTestUser ||
        this.isB2BPackage
      );
    },
    isB2BPackageDisabled() {
      return (
        this.isFilteredByFastFix ||
        this.isEmptyPricePackage ||
        this.isOnlyTestUser ||
        this.isOnlyNonVerifySales ||
        this.isUnAppointed
      );
    },
  },
  watch: {
    "$route.query": async function onRouteQueryChange() {
      this.setupQuery();
      await this.setupData();

      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0;
    },
    'query.packageName': function onPackageNameChange(newValue, oldValue) {
      // If user types manually (not selecting from suggestions), clear packageId
      if (newValue !== oldValue && !this.isSelectingFromSuggestions) {
        this.query.packageId = null;
      }
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupQuery();
      this.setupData();
    },
    setupQuery() {
      try {
        this.selectedProject = this.$route.query.projectId
          ? { projectId: this.$route.query.projectId, projectName: this.$route.query.projectId }
          : null;

        this.query = {
          firstName: this.$route.query.firstName || null,
          lastName: this.$route.query.lastName || null,
          page: parseInt(this.$route.query.page, 10) || 1,
          addressNumber: this.$route.query.addressNumber || undefined,
          status: this.$route.query.status || null,
          category: this.$route.query.category || null,
          homeId: this.$route.query.homeId || null,
          projectId: this.$route.query.projectId || null,
          packageName: this.$route.query.packageName || null,
          packageId: this.$route.query.packageId || null
        };

        this.isFilteredByFastFix = !isNil(this.$route.query.serviceType);
        this.isEmptyPricePackage = Boolean(this.$route.query.isEmptyPricePackage);
        this.isOnlyTestUser = Boolean(this.$route.query.isOnlyTestUser);
        this.isOnlyNonVerifySales = Boolean(this.$route.query.isOnlyNonVerifySales);
        this.isOnlyOutsideSystem = Boolean(this.$route.query.isOnlyOutsideSystem);
        this.isUnAppointed = Boolean(this.$route.query.isUnAppointed);
        this.isB2BPackage = Boolean(this.$route.query.isB2BPackage);
      } catch (err) {
        this.query = {
          firstName: this.$route.query.firstName || null,
          lastName: this.$route.query.lastName || null,
          page: 1,
          addressNumber: this.$route.query.addressNumber || undefined,
          status: this.$route.query.status || null,
          category: this.$route.query.category || null,
          homeId: this.$route.query.homeId || null,
          projectId: this.$route.query.projectId || null,
          packageName: this.$route.query.packageName || null,
          packageId: this.$route.query.packageId || null
        };

        this.isFilteredByFastFix = !isNil(this.$route.query.serviceType);
        this.isEmptyPricePackage = Boolean(this.$route.query.isEmptyPricePackage);
        this.isOnlyTestUser = Boolean(this.$route.query.isOnlyTestUser);
        this.isOnlyNonVerifySales = Boolean(this.$route.query.isOnlyNonVerifySales);
        this.isOnlyOutsideSystem = Boolean(this.$route.query.isOnlyOutsideSystem);
        this.isUnAppointed = Boolean(this.$route.query.isUnAppointed);
        this.isB2BPackage = Boolean(this.$route.query.isB2BPackage);
      }
    },
    async setupData() {
      await this.setupList();
    },
    async setupList() {
      this.isLoading = true;
      const params = this.queryParams;

      const { count, subscribers } = await this.fetchList(params);

      this.total = count;

      this.list = subscribers.map(item => {
        const {id} = item;
        const userName = `${item.owner.first_name} ${item.owner.last_name}`;
        const phoneNumber = item.owner.mobile_number || "-";
        
        let offlinePurchase
        if (item.is_user_for_offline_purchase_by_admin) {
          offlinePurchase = 'ซื้อนอกระบบ'
        } else if (item.is_non_verify_sales) {
          offlinePurchase = 'ซื้อโดยไม่สมัคร App'
        } else {
          offlinePurchase = ''
        }

        const user = { name: userName, phoneNumber, offlinePurchase };
        const home = {
          addressNumber: item.home ? item.home.address_no : "",
          project: item.project ? item.project.project_name : ""
        };

        const invoice = item.invoices[0];

        const pack = {
          name: item.current_package.name,
          price: item.price
           ? item.price
           : item.current_package.price,
          billingCycle: item.current_package.billing_cycle,
          couponCode: invoice && invoice.coupon && invoice.coupon.code,
          discountAmount: invoice && invoice.coupon && invoice.coupon.discount_amount,
          paymentAmount: invoice && invoice.total,
          totalCoinAmount: invoice && invoice.total_coin_amount,
          originalPrice: item.current_package.original_price,
        };
        const route = { name: "SubscriberDetailPage", params: { id } };

        const purchasedAt = DateTime.fromISO(item.purchased_at).toUTC();
        const renewAt = DateTime.fromISO(item.renew_at).toUTC();
        const {status} = item;
        const appointmentDate =
          item.current_appointment && item.current_appointment.date_time
            ? DateTime.fromISO(item.current_appointment.date_time).toUTC()
            : undefined;

        const appointmentDurationTime = getDurationAppointmentTimeText(
          item.current_appointment && item.current_appointment.date_time,
          item.current_appointment && item.current_appointment.date_time_end
        )

        const {category} = item;
        const quantity = item.quantity || 1;

        return {
          id,
          user,
          home,
          packageInfo: pack,
          route,
          purchasedAt,
          renewAt,
          status,
          appointmentDate,
          category,
          quantity,
          appointmentDurationTime
        };
      });
      this.isLoading = false;
    },
    async fetchList(params) {
      const response = await baanRueJaiClient.admin.subscriptions.subscribers.list(
        params
      );

      return response.data.result;
    },
    async handleSearch() {
      const projectId = this.selectedProject
        ? this.selectedProject.projectId
        : null
      const query = this.isFilteredByFastFix
        ? {
            ...this.query,
            projectId,
            serviceType: "FAST_FIX",
            page: 1
          }
        : { ...this.query, projectId, page: 1 };
      const route = {
        name: this.$route.name,
        query
      };

      if (this.isEmptyPricePackage) {
        query.isEmptyPricePackage = this.isEmptyPricePackage;
      }

      if (this.isOnlyTestUser) {
        query.isOnlyTestUser = this.isOnlyTestUser;
      }

      if (this.isOnlyNonVerifySales) {
        query.isOnlyNonVerifySales = this.isOnlyNonVerifySales;
      }

      if (this.isOnlyOutsideSystem) {
        query.isOnlyOutsideSystem = this.isOnlyOutsideSystem;
      }

      if (this.isUnAppointed) {
        query.isUnAppointed = this.isUnAppointed;
      }

      if (this.isB2BPackage) {
        query.isB2BPackage = this.isB2BPackage;
      }

      this.$router.replace(route);
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page }
      };

      this.$router.replace(route);
    },
    handleChangeReportStatus(value) {
      this.selectedReportStatus = value;
    },
    async handleClickDownloadReport() {
      const params = {
        status: this.query.status || this.$route.query.status,
        category: this.query.category || this.$route.query.category
      }

      if (!this.query.status && !this.query.category) {
        this.$message.error("กรุณาเลือกสถานะหรือประเภทก่อน Download Report");
        return;
      }

      try {
        const response = await baanRueJaiClient.admin.subscriptions.subscribers.getReport(
          params
        );

        getDownloadedReport(response.data, `list-subscriber-${params.status || params.category}.xlsx`);
      } catch(error) {
        // TODO: use alert message from response message backend
        this.$message.error("ไม่สามารถ Download Report ได้ เนื่องจากไม่มีข้อมูลหรือเกิดข้อผิดพลาด");
      }
    },
    async fetchPackageSuggestions(queryString, callback) {
      if (!queryString || queryString.length < 2) {
        callback([]);
        return;
      }

      try {
        const response = await baanRueJaiClient.admin.subscriptions.recommend_packages.search({
          search_text: queryString,
          take: 10
        });

        const packages = response.data.result.packages || [];
        const suggestions = packages.map(pkg => ({
          name: pkg.name,
          price: pkg.price,
          id: pkg.id,
          value: pkg.name
        }));

        callback(suggestions);
      } catch (error) {
        callback([]);
      }
    },
    handlePackageSelect(item) {
      this.isSelectingFromSuggestions = true;
      this.query.packageName = item.name;
      this.query.packageId = item.id;
      this.$nextTick(() => {
        this.isSelectingFromSuggestions = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: ($space / 2) $space;
}

.row-header {
  display: grid;
  grid-template-columns: 120px repeat(4, 1fr) 200px 100px repeat(1, 1fr);
  padding: ($space / 2) $space;

  grid-gap: 15px;

  border-bottom: $border;

  font-weight: bold;

  > .center {
    text-align: center;
  }
}

.header {
  padding: 30px;
  border-bottom: $border;
}

.checkbox {
  &-only-fast-fix {
    margin-top: 0.118rem;
  }

  &-font {
    font-size: 16px;
  }
}

.download-report-message {
  font-size: 15px;
}

.package-suggestion {
  .package-name {
    font-weight: bold;
    margin-bottom: 4px;
  }
  
  .package-price {
    color: #666;
    font-size: 14px;
  }
}

.el-autocomplete {
  width: 100% !important;
  
  .el-input {
    width: 100% !important;
  }
}
</style>
